import React, { memo } from 'react';
import { useFeatureFlags, useLoggedInUser } from '@tcc/shared-data-lib';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { MarketingBannerContainer } from '../../components/MarketingBanner';

interface IProps {
  operationsSelected: Operation[];
}

// Runtime dependency
const FieldSelectionPlugin: React.FC<IProps> = React.lazy(() =>
  importFromS3('field-selection-web')
);

const MARKETING_BANNER_FF = 'web.field-selection.marketing-notification-banner';

export const FieldSelectionPluginContainer = memo(
  ({ operationsSelected }: IProps) => {
    const { user } = useLoggedInUser(useUserLoggedInConfigs);
    const { featureFlags, isLoading } = useFeatureFlags(useFeatureFlagsConfigs(user));

    const isMarketingBannerEnabled = !isLoading && featureFlags?.[MARKETING_BANNER_FF];

    return (
      <>
        {isMarketingBannerEnabled && <MarketingBannerContainer />}
        <FieldSelectionPlugin operationsSelected={operationsSelected} />
      </>
    );
  }
);
